import { getOSSymbolInfo } from "@/canv/utils";
import type { MenuItemsList } from "@/interface/ContextMenu/types";
import { decodeHtml } from "@/shared/lib/decodeHtml";

const ACTION_SYMBOL = decodeHtml(getOSSymbolInfo().actionSymbol);
const SUBMENU_SYMBOL = decodeHtml(`&#62`);
const DELETE_SYMBOL = decodeHtml(`&#9003;`);

export const OFFSET = 10;
export const PADDING_SUBMENU = 16;
export const WIDGET_MENU_PADDING = 4;

export const ARRANGE_SUB_MENU = [
    { label: "Левый край", name: "alignLeft", shortCut: "" },
    {
        label: "Центры горизонтально",
        name: "alignHCenters",
        shortCut: "",
    },
    { label: "Правый край", name: "alignRight", shortCut: "" },
    { label: "Верхний край", name: "alignTop", shortCut: "" },
    {
        label: "Центры вертикально",
        name: "alignVCenters",
        shortCut: "",
    },
    { label: "Нижний край", name: "alignBottom", shortCut: "" },
];
export const MENU_ITEMS_LIST: MenuItemsList = [
    { id: 1, name: "copy", label: "Скопировать", shortCut: `${ACTION_SYMBOL} C` },
    { id: 2, name: "paste", label: "Вставить", shortCut: `${ACTION_SYMBOL} V` },
    { id: 3, name: "comment", label: "Комментировать", shortCut: "C" },
    { id: 4, name: "divider", label: "" },
    { id: 5, name: "toFront", label: "Перенести вперед", shortCut: `${ACTION_SYMBOL} ]` },
    { id: 6, name: "toBack", label: "Перенести назад", shortCut: `${ACTION_SYMBOL} [` },
    {
        id: 7,
        name: "arrange",
        label: "Выровнять",
        shortCut: SUBMENU_SYMBOL,
        submenu: ARRANGE_SUB_MENU,
    },
    { id: 8, name: "divider", label: "" },
    { id: 9, name: "redo", label: "Шаг вперед", shortCut: `${ACTION_SYMBOL} + Z` },
    { id: 10, name: "undo", label: "Шаг назад", shortCut: `${ACTION_SYMBOL} + Shift + Z` },
    { id: 11, name: "divider", label: "" },
    { id: 12, name: "copyAsPng", label: "Скопировать как PNG" },
    { id: 13, name: "export", label: "Экспортировать" },
    { id: 14, name: "linkToWidget", label: "Скопировать ссылку" },
    { id: 15, name: "divider", label: "" },
    { id: 16, name: "delete", label: "Удалить", shortCut: DELETE_SYMBOL },
    { id: 17, name: "addSticker", label: "Добавить стикер", shortCut: "N" },
    { id: 18, name: "addText", label: "Добавить текст", shortCut: "T" },
    { id: 19, name: "addShape", label: "Добавить фигуру", shortCut: "S" },
];
